export default __webpack_public_path__ + "static/media/aroma20.a9b55046.png";